import {Component, OnInit, ViewChild} from '@angular/core';
import {Imovel} from '../imoveis/models/imovel.model';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LeadService} from '../core/services/lead.service';
import {ToastrService} from 'ngx-toastr';
import {AllImoveis} from '../core/services/all-imoveis.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MASKS} from 'ng-brazil';
import {HttpClient} from '@angular/common/http';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Observable, of, Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {getFormattedPrice, toArea, toBath, toDormis, toSalas, toVaga} from '../core/utils/imovel.util';
import {NextToastComponent} from '../core/components/next-toast/next-toast.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-imovel',
  templateUrl: './imovel.component.html',
  styleUrls: ['./imovel.component.css']
})
export class ImovelComponent implements OnInit {

  imovel: Imovel;

  similar: Imovel[] = [];
  similarKey: "locacao" | "venda" = "venda"

  imageheight = (window.innerWidth > 1300 ? 500 : (window.innerWidth > 992 ? 480 : 300)) + 'px';

  imgs: Array<object>;

  apiLoaded: Observable<boolean>;

  owlOptions:OwlOptions = {
    dots: false,
    loop: true,
    margin: 10,
    nav: false,
    autoHeight: true,
    autoplay: true,
    navText:['<', '>'],
    responsive:{
      0:{
        items:1
      },
      768:{
        items:2
      },
      991:{
        items:3
      },
    }
  }

  @ViewChild('toast') toast: NextToastComponent;

  @ViewChild('content') public childModal: NgbModalRef;

  form: FormGroup;
  MASKS = MASKS;

  toSalas = toSalas;
  toDormis = toDormis;
  toArea = toArea;
  toBath = toBath;
  toVaga = toVaga;
  getFormattedPrice = getFormattedPrice;

  subRouter: Subscription;


  constructor(
    private route: ActivatedRoute,
    private all: AllImoveis,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private service: LeadService,
    private toastr: ToastrService,
    private router: Router,
    private httpClient: HttpClient
  ) {

  }

  ngOnInit() {
    this.apiLoaded = this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${environment.maps.key}`, 'callback')
      .pipe(
        map(() => true),
        catchError(() => of(false)),
      );

    this.subRouter = this.route.params.pipe(
      switchMap(() => this.all.imoveis$)
    ).subscribe((imoveis:Imovel[]) => {
      const { id } = this.route.snapshot.params;
      const imovel:Imovel | undefined = imoveis.find((im) => im.sigla === id) || undefined;

      if(imovel){
        // console.log(imovel);
        this.imovel = imovel;
        this.imgs = this.imageObject()
        this.similar = this.similarImovel(imoveis);
      }
    })
    // cd-google-map
  }

  similarImovel(imoveis:Imovel[]): Imovel[]{
    const { minimumPrice, maximumPrice } = this.precoImovelAtual()
    return imoveis
    .filter((im) => {
      if(
        this.imovel.tipo === im.tipo &&
        im.comercializacao[this.similarKey]?.ativa &&
        typeof im.comercializacao[this.similarKey].preco === "number" &&
        im.comercializacao[this.similarKey].preco <= maximumPrice &&
        im.comercializacao[this.similarKey].preco >= minimumPrice &&
        !im.sigla.includes(this.imovel.sigla)
      ){
        return im
      }
    })
    .sort(() => Math.random() - 0.5)
    .slice(0, 6)
  }

  precoImovelAtual():{ minimumPrice: number, maximumPrice:number } {
    if(this.imovel.comercializacao.locacao?.ativa){
      this.similarKey = "locacao"
    } else {
      this.similarKey = "venda"
    }
    const price = this.imovel.comercializacao[this.similarKey].preco
    const percentValue = 20 * price / 100

    return {
      minimumPrice: price - percentValue,
      maximumPrice: price + percentValue
    }
  }

  back(): void {
    const strParams = localStorage.getItem('results')
    const params = JSON.parse(strParams) || {};
    this.router.navigate(
      ['/imoveis'],
      {
        queryParams: {
          ...params
        }
      }
    )
  }

  scroll() {
    document.getElementById('down-arrow').scrollIntoView({behavior: 'smooth'});
  }

  imageObject(): Array<object> {
    if (this.imovel.midia.imagens) {
      this.imgs = this.imovel.midia.imagens.map(value => {
        return {
          image: value,
          thumbImage: value
        };
      });
    }
    if (this.imovel.midia.fotoscond) {
      this.imovel.midia.fotoscond.map(value => {
        return {
          image: value,
          thumbImage: value
        };
      }).forEach(value => this.imgs.push(value));
    }
    return this.imgs;
  }

  buildForm() {
    this.form = this.formBuilder.group({
      nome: [, Validators.required],
      email: [, [Validators.required, Validators.email]],
      telefone: [],
      mensagem: ['Quero saber mais sobre o imovél: ' + this.imovel.sigla],
    });
  }

  submitForm() {

    let text_message:string = this.form.get('mensagem').value;

    if (this.imovel) {
      text_message = "Imóvel: " + this.imovel.local?.bairro + "," + this.imovel.local?.cidade +
        "\nLink: " + window.location.href +
        "\n-------------------------------------------------\n" +
        this.form.get('mensagem').value;
    }

    const form = new FormData();
    form.append('nome', this.form.get('nome').value);
    form.append('email', this.form.get('email').value);
    form.append('telefone', this.form.get('telefone').value);
    form.append('mensagem', text_message);
    this.service.sendToContactForm(form, 504).subscribe(value => {
      this.modalService.dismissAll();
      this.toastr.success('Contato enviado!', 'Seus dados foram enviados com sucesso!');
    });
  }


  anualOrMonth(label?: string) {
    let l = 'mês';
    if (label === 'anual') {
      l = 'anual';
    }
    return l;
  }

  theTotal() {
    let total = 0;
    if (this.imovel?.comercializacao?.locacao?.preco) {
      total += this.imovel?.comercializacao?.locacao?.preco;
    }

    if (this.imovel?.comercializacao?.taxa?.condominio) {
      total += this.imovel?.comercializacao?.taxa?.condominio;
    }

    if (this.imovel?.comercializacao?.taxa?.iptu) {
      total += this.imovel?.comercializacao?.taxa?.iptu;
    }

    return getFormattedPrice(total).replace('R$', '');

  }

  open(content) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      // @ts-ignore
      size: 'md',
      centered: true
    }).result.then((result) => {
    }, (reason) => {
    });
  }

  openToast(title: string, text: string) {
    this.toast.title = title;
    this.toast.text = text;
    this.toast.show = true;

  }

  whatsapp() {
    window.open('https://api.whatsapp.com/send?text=http://nextsim.com.br/imoveis/' + this.imovel.sigla, '_blank');
  }

  ngOnDestroy():void{
    this.subRouter.unsubscribe();
  }

  formatedPrice(imovel:Imovel):string{
    return Intl
    .NumberFormat("pt-BR",{ style: "currency", currency: "BRL" })
    .format(imovel.comercializacao[this.similarKey].preco)
  }
}

export class ContactForm {
  constructor(
    public nome: string,
    public telefone: string,
    public email: string,
    public texto?: string,
    public interesse = 0,
    public midia = 0
  ) {
  }
}
